var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-change"},[_c('span',[_vm._v("\n        "+_vm._s(_vm.action.label)+"\n        "),_c('ui-tooltip',{attrs:{"open-on":"click"}},[_vm._v(_vm._s(_vm._f("humanDayTime")(_vm.action.chronology_date)))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }